const e = {
  tighter: "-0.05em",
  tight: "-0.025em",
  normal: "0",
  wide: "0.0375rem",
  wider: "0.075rem",
  widest: "0.1em"
}, t = e;
export {
  t as default,
  e as letterSpacings
};
